import fetch from "auth/FetchInterceptor";

const RegistrationsService = {};

const registrationsPrefix = "/registrations";

RegistrationsService.getRegistrations = async (type) =>
  await fetch(`${registrationsPrefix}`, {
    method: "GET",
  });

RegistrationsService.getPendingRegistrations = async (type) =>
  await fetch(`${registrationsPrefix}/pending`, {
    method: "GET",
  });

RegistrationsService.getRegistrationById = async (id) =>
  await fetch(`${registrationsPrefix}/${id}`, {
    method: "GET",
  });

RegistrationsService.validateRegistration = async (id, data) =>
  await fetch(`${registrationsPrefix}/${id}/validate`, {
    method: "PATCH",
    data,
  });

RegistrationsService.rejectRegistration = async (id, data) =>
  await fetch(`${registrationsPrefix}/${id}/reject`, {
    method: "PATCH",
    data,
  });

RegistrationsService.updateReceipt = async (id, formData) =>
  await fetch(`${registrationsPrefix}/updateReceipt/${id}`, {
    method: "PATCH",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

RegistrationsService.createTutorialRegistration = async (tutorialId, data) =>
  await fetch(`${registrationsPrefix}/tutorials/${tutorialId}`, {
    method: "POST",
    data,
  });
export default RegistrationsService;
